import { disableFormSubmissionIfInvalid } from '../util/disable_form_submission_if_invalid';
import { typewriterAnimation } from '../components/typewriter_animation';
import { maybeAddCelloUccToForm } from '../components/cello';
window.up.compiler('.js-publication_creation_form', form => {
    const submitButton = form.querySelector('.js-publication_creation_submit');
    maybeAddCelloUccToForm(form);
    disableFormSubmissionIfInvalid(form, submitButton);
});
window.up.compiler('.js-publication_creation_new_heading', element => {
    typewriterAnimation(element, { typingSpeed: 300, holdTime: 200, wordShouldDisappear: true });
});
